import { useEffect, useRef } from 'react';

export function usePrevious(value) {
  const previous = useRef(undefined);

  useEffect(() => {
    previous.current = value;
  });

  // Classic "previous value" hook — reading ref during render is intentional here.
  // oxlint-disable-next-line react-hooks/refs
  return previous.current;
}
